// extracted by mini-css-extract-plugin
export default {"container":"feed-user_container__Z2rA6"};